<template>
  <el-dialog
    show-close
    visible
    :width="'1100px'"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :disabled="disabled"
      :isChange="isChange"
      :amzPurchaseDetailCode="amzPurchaseDetailCode"
      :purchaseQty.sync="purchaseQty"
      @close="close"
      @reload="$emit('reload')"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ $l('INDEX.btn_cancel') || 取消 }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        v-if="!disabled"
        @click="$refs.main.save()"
      >
        {{ $l('INDEX.btn_save') || 保存 }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    type: { type: String, default: '' },
    amzPurchaseDetailCode: { type: String, default: '' },
    purchaseQty: { type: Number, default: 0 },
  },
  data() {
    return {
      titleMap: {
        editShortage: this.$l('dialog_title_editShortage') || '短装数量修改',
        viewShortage:
          this.$l('dialog_title_viewShortage') || '短装数量修改查询',
      },
    }
  },
  computed: {
    title() {
      return this.titleMap[this.type]
    },
    disabled() {
      return this.type === 'viewShortage'
    },
    isChange() {
      return this.type === 'change'
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
